import React from 'react';
import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';

// Import pages
import HomePage from './pages/HomePage';
import SongPage from './pages/SongPage';
import AdvancedPage from './pages/AdvancedPage';
import AdvancedSongPage from './pages/AdvancedSongPage';
import PrintPage from './pages/PrintPage';
import QRCodesPrintPage from './pages/QRCodesPrintPage';
import FolderSongPage from './pages/FolderSongPage';
import DebugScoresPage from './pages/DebugScoresPage';
import ExternalHomePage from './pages/ExternalHomePage';
import ExternalSongPage from './pages/ExternalSongPage';
import GroupSharePage from './pages/GroupSharePage';

// Styled components for layout with dark theme and red accents
const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #1a1a1a;
  color: #ffffff;
`;

const Header = styled.header`
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 2px solid #cc0000;
  padding: 1rem;
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 100;
`;

const Title = styled.h1`
  color: #cc0000;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const MainContent = styled.main`
  flex: 1;
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

const ContentWrapper = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  min-height: 70vh;
  overflow: hidden;
  border: 1px solid rgba(204, 0, 0, 0.2);
`;

const Footer = styled.footer`
  background: rgba(0, 0, 0, 0.9);
  border-top: 1px solid #cc0000;
  padding: 1rem;
  text-align: center;
  color: #cccccc;
  font-size: 0.8rem;
`;

function App() {
  return (
    <AppContainer>
      <Header>
        <Title>AKApella</Title>
      </Header>
      
      <MainContent>
        <ContentWrapper>
                  <Routes>
                    {/* Home page with song list */}
                    <Route path="/" element={<HomePage />} />
                    
                    {/* Advanced song page */}
                    <Route path="/advanced/song/:id" element={<AdvancedSongPage />} />
                    
                    {/* Advanced management page */}
                    <Route path="/advanced" element={<AdvancedPage />} />
                    
                    {/* Individual song page */}
                    <Route path="/song/:id" element={<SongPage />} />
                    
                    {/* External pages */}
                    <Route path="/external" element={<ExternalHomePage />} />
                    <Route path="/external/song/:id" element={<ExternalSongPage />} />
                    
                    {/* Print page */}
                    <Route path="/print/:id" element={<PrintPage />} />
                    <Route path="/print/qr-codes" element={<QRCodesPrintPage />} />
                    
                    {/* Folder page */}
                    <Route path="/folder/song/:id" element={<FolderSongPage />} />

                    {/* Shared song group */}
                    <Route path="/group/:slug" element={<GroupSharePage />} />
                    
                    {/* Debug page */}
                    <Route path="/debug/scores" element={<DebugScoresPage />} />
                    
                    {/* 404 page */}
                    <Route path="*" element={
                      <div style={{ 
                        padding: '3rem', 
                        textAlign: 'center',
                        color: '#cccccc'
                      }}>
                        <h2>Page not found</h2>
                        <p>The page you're looking for doesn't exist.</p>
                      </div>
                    } />
                  </Routes>
        </ContentWrapper>
      </MainContent>
      
      <Footer>
        <p>Sheet Music Tracker v1.0.0</p>
      </Footer>
    </AppContainer>
  );
}

export default App;

